import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';

// Stable code on the seeded 'Campaign' system source. Each agency has its own
// opportunity_source row (with its own UUID) carrying isSystem=true and this
// code — selecting it on an opportunity reveals the campaign-link field on
// the create/edit forms. Kept in sync with OPPORTUNITY_SOURCE_CODE_CAMPAIGN
// in api/core/opportunity_sources.go.
export const OPPORTUNITY_SOURCE_CODE_CAMPAIGN = 'campaign';

export default class OpportunitySourceDto extends BaseAgencyScopeEntityDto {
    status = 0;
    name = '';
    code = '';
    isSystem = false;
}
